import React, { useContext, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Button from "../../../../lib/ui/buttons/Button";
import Checkbox from "../../../../lib/ui/checkbox/Checkbox";
import StripeCheckout from "react-stripe-checkout";
import { LangCtx, CustomCtx } from "../../../../lib/context";
import { toast } from "react-toastify";
import InputField from "../../../../lib/ui/inputs/Input";
import { validateEmail } from "../../../../lib/validation";

const Confirmation = (props) => {
    const { l } = useContext(LangCtx);
    const { custom } = useContext(CustomCtx);
    const [cheked, setValue] = useState(false);
    const [error, setError] = useState(false);
    const [email, setEmail] = useState("");
    const check_ref = useRef(null);
    const { keys, currency } = props;
    const handleNext = (token) => {
        if (cheked) {
            if (email && email !== "") {
                if (validateEmail(email)) {
                    // props.handleInvitedEmail(email);
                    setError(false);
                    if (props?.docData?.paymentType === "free" || props?.docData?.paymentType === "postPaid") {
                        props.handleFreeAppointment();
                    } else {
                        props.handleConfirm(token);
                    }
                } else {
                    toast.error("Please enter valid email");
                }
            } else {
                setError(false);
                if (props?.docData?.paymentType === "free" || props?.docData?.paymentType === "postPaid") {
                    props.handleFreeAppointment();
                } else {
                    props.handleConfirm(token);
                }
            }
        } else {
            setError(true);
        }
    };

    const handleTC = () => {
        setError(true);
    };

    const handleEmailChange = (event) => {
        const eml = event.target.value;
        setEmail(eml);
        if (validateEmail(eml)) {
            props.handleInvitedEmail(eml);
        }
    };

    return (
        <div className="baColBlock">
            <div className="pdngXS">
                <span className="pdngVXS">Guest Email ID</span>
                <InputField placeholder="Enter guest email ID" type="email" maxLength="30" value={email} onChange={handleEmailChange} />
            </div>
            {error && error !== "" && <span className="redTxt errorTxt">{l.click_check}</span>}
            <div className="termsRow">
                <Checkbox
                    onClick={(e) => setValue(e.target.checked)}
                    type="checkbox"
                    id="1"
                    name="confirm"
                    value=""
                    for="1"
                    checked={cheked}
                />
                <p className="pTxt">
                    {l.conf_reason}
                    {/* <Link to="/terms-conditions" target="_blank" className="linkTxt linkTxtSm">
                        {l.terms_cond}
                    </Link> */}
                    <Link to="/patient-concern" target="_blank" className="linkTxt linkTxtSm">
                        Patient Concerns,
                    </Link>
                    {" " + l.conf_reason_desc}
                </p>
            </div>
            <div className="baFtrGtnGroup">
                <Button size="md" className="btn" type="primary" onClick={() => props.handleNext({}, "FU")} label={l.previous} />
                {cheked ? (
                    process.env.REACT_APP_payment === "true" && props?.docData?.paymentType === "prePaid" ? (
                        <StripeCheckout
                            name={custom.subDomain}
                            description="Unified Consultaion" // the pop-in header subtitle
                            image={custom.logo}
                            ComponentClass="div"
                            panelLabel="Pay"
                            currency={currency}
                            ref={check_ref}
                            closed={props.onClose()}
                            stripeKey={keys.clientstripekey}
                            token={(token) => handleNext(token)}
                        >
                            <Button label={l.confirm_and_Pay} type="primary" size="md" fullWidth="fullWidth" />
                        </StripeCheckout>
                    ) : (
                        <Button
                            label={l.confirm}
                            type="primary"
                            size="md"
                            // fullWidth="fullWidth"
                            onClick={(e) => handleNext(null)}
                        />
                    )
                ) : process.env.REACT_APP_payment === "true" ? (
                    <Button label={l.confirm} type="primary" size="md" className="btn" onClick={handleTC} />
                ) : (
                    <Button label={l.confirm_and_Pay} type="primary" size="md" className="btn" onClick={handleTC} />
                )}
                {/* <Button
                    size="md"
                    className="btn"
                    type="primary"
                    onClick={handleNext}
                    label={l.confirm_and_Pay}
                />*/}
            </div>
        </div>
    );
};

export default Confirmation;
